import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Locale } from "../../locales/locales";
import { LocaleContext } from "../../locales/LocaleProvider";

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const { locale, setLocale } = useContext(LocaleContext);

  const onLanguageChange = (locale: Locale) => {
    i18n.changeLanguage(locale);
    setLocale(locale);
  };

  return (
    <div className="flex items-center justify-center space-x-4">
      <button
        className={`w-8 ${locale === Locale.zhCN ? "text-yellow-400" : ""}`}
        onClick={(e) => onLanguageChange(Locale.zhCN)}
      >
        中文
      </button>
      <button
        className={`w-8 ${locale === Locale.en ? "text-yellow-400" : ""}`}
        onClick={(e) => onLanguageChange(Locale.en)}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSelector;
